module.exports = __webpack_public_path__ + "static/media/smart-search.b764fd5b.svg";